import { LogLevel } from "@azure/msal-browser";

export const b2cPolicies = {
  names: {
    signUpSignIn: process.env.REACT_APP_POLICIES_NAME_SIGN_UP_SIGN_IN,
    forgotPassword: process.env.REACT_APP_POLICIES_NAME_FORGOT_PASSWORD,
    deactivate: process.env.REACT_APP_POLICIES_NAME_DEACTIVATE,
    changePassword: process.env.REACT_APP_POLICIES_NAME_CHANGE_PASSWORD,
    editmfanumber: process.env.REACT_APP_POLICIES_NAME_EDIT_MFA_NUMBER,
    profileUpdate: process.env.REACT_APP_POLICIES_NAME_PROFILE_EDIT,
    totpauthenticator: process.env.REACT_APP_POLICIES_NAME_TOTP_NUMBER,
  },
  authorities: {
    signUpSignIn: {
      authority: process.env.REACT_APP_AUTHORITIES_SIGN_UP_SIGN_IN,
    },
    forgotPassword: {
      authority: process.env.REACT_APP_AUTHORITIES_FORGOT_PASSWORD,
    },
    changePassword: {
      authority: process.env.REACT_APP_AUTHORITIES_CHANGE_PASSWORD,
    },
    profileUpdate: {
      authority: process.env.REACT_APP_AUTHORITIES_PROFILE_UPDTAE,
    },
    deactivate: {
      authority: process.env.REACT_APP_AUTHORITIES_DEACTIVATE,
    },

    editmfanumber: {
      authority: process.env.REACT_APP_AUTHORITIES_EDIT_MFA_NUMBER,
    },
    totpauthenticator: {
      authority: process.env.REACT_APP_AUTHORITIES_EDIT_TOTP_NUMBER,
    },
  },
  authorityDomain: process.env.REACT_APP_AUTHORITY_DOMAIN,
};

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: window.location.origin,
    postLogoutRedirectUri: process.env.REACT_APP_POST_REDIRECT_URL, // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            return;
          case LogLevel.Info:
            return;
          case LogLevel.Verbose:
            return;
          case LogLevel.Warning:
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "offline_access",
    process.env.REACT_APP_ACCESS_TOKEN_SCOPE
  ],
};
export const silentRequest = {
  scopes: ["openid", "profile", "offline_access",
    process.env.REACT_APP_ACCESS_TOKEN_SCOPE

  ],
};

export const protectedResources = {
  apiHello: {
    endpoint: "https://appsapi.uvation.com/identity/hello",
    scopes: [`https://${process.env.REACT_APP_TENANT_ID}/tasks-api/tasks.read`], // e.g. api://xxxxxx/access_as_user
  },
};
